import { hList } from "constants/architectsTranslation";

function HListSection({ text }: hList) {
  return (
    <div className="p-0 d-flex flex-column" style={{ listStyle: "none" }}>
      {text.map((text, index) => (
        <span className="p-0 me-3" key={index}>
          -{text}
        </span>
      ))}
    </div>
  );
}

export default HListSection;
